import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { App as MyApp, AppRoutes } from './app';
import { unregister } from './serviceWorker';
import './styles/index.scss';
import { setDefaultOptions } from 'esri-loader';

setDefaultOptions({ version: '4.20', css: true });

const basename = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL.split('/').pop()
  : '';

const Root = () => (
  <React.StrictMode>
    <MyApp>
      <Router basename={`/${basename}`}>
        <AppRoutes />
      </Router>
    </MyApp>
  </React.StrictMode>
);

ReactDOM.render(<Root />, document.getElementById('root'));

unregister();
